import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { AuthenticationService } from '../services/authentication.service';
import { UtilityService } from '../services/utility.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
      private util: UtilityService,
      private auth: AuthenticationService,
    ) { }

    canActivate(): Promise<boolean> {

        return this.auth.isAuthenticated()
            .then(() => true)
            .catch(() => {
                this.util.navigateToLoginPage();
                return false;
            });
    }

    canLoad(): Promise<boolean> {

        return this.auth.isAuthenticated()
            .then(() => true)
            .catch(() => {
                this.util.navigateToLoginPage();
                return false;
            });
    }
}
